/**
 * User Preferences Types
 *
 * Typed interfaces for the values stored in the preferences JSONB column.
 */

export type Theme = 'light' | 'dark' | 'system';

export type CoachingStyle = 'encouraging' | 'direct' | 'analytical';

export interface NotificationPreferences {
  settlement_reminders: boolean;
  budget_alerts: boolean;
  goal_milestones: boolean;
}

export interface AiPreferences {
  coaching_style: CoachingStyle;
  dismissed_insights: string[];
  fire_mode_enabled: boolean;
  markets_enabled: boolean;
  onboarding_completed: boolean;
}

/** All keys are optional — the column starts as `{}`. */
export interface AppPreferences {
  theme?: Theme;
  dismissed_budget_suggestions?: string[];
  notifications?: Partial<NotificationPreferences>;
  ai?: Partial<AiPreferences>;
}

export const DEFAULT_NOTIFICATIONS: NotificationPreferences = {
  settlement_reminders: true,
  budget_alerts: true,
  goal_milestones: true,
};

export const DEFAULT_AI: AiPreferences = {
  coaching_style: 'encouraging',
  dismissed_insights: [],
  fire_mode_enabled: false,
  markets_enabled: false,
  onboarding_completed: false,
};
